<template>
  <div>
    <v-expansion-panels
      v-model="openedExpansions"
      :multiple="!!$route.query.embed"
      flat
      accordion
    >
      <v-expansion-panel
        v-for="(item, i) in noSectorList
          ? noSectorList.filter((i) =>
              group ? i[0].nome_grupo : !i[0].nome_grupo
            )
          : []"
        :key="i"
        :disabled="!hasProductAvaiable(item)"
      >
        <v-expansion-panel-header
          :style="
            i === 0 && !group
              ? 'min-height: 90px'
              : 'border-top: 1px solid #dfdfdf; height: 90px'
          "
        >
          <v-row no-gutters align="center">
            <v-col cols="10">
              <v-row no-gutters>
                <span
                  class="checkout-h6 accent--text"
                  style="font-weight: 450 !important"
                  >{{ item[0].nome }}</span
                >
              </v-row>
              <v-row class="mt-2" no-gutters>
                <span
                  v-if="hasProductAvaiable(item)"
                  class="checkout-h5 primary--text"
                  style="font-weight: normal"
                  >{{ rangeByType(item) }}</span
                >
              </v-row>
            </v-col>
            <v-spacer></v-spacer>

            <v-chip v-if="!hasProductAvaiable(item)" outlined color="#838D9B"
              >Esgotado</v-chip
            >

            <v-tooltip v-if="item[0]?.observacoes" color="orange" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  size="24"
                  class="mr-2"
                  color="orange"
                  @click.stop="() => {}"
                  style="cursor: default !important"
                  v-bind="attrs"
                  v-on.stop="on"
                  >mdi-information</v-icon
                >
              </template>
              <v-row style="width: 200px !important" no-gutters>
                <span>{{ item[0].observacoes }}</span>
              </v-row>
            </v-tooltip>
            <v-chip
              v-if="totalByProduct(item)"
              color="primary"
              class="pa-0 ma-0 mr-4 circle-quantity"
            >
              <span class="white--text">{{ totalByProduct(item) }}</span>
            </v-chip>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="expansion-content">
          <NoExpandedProducts
            v-for="(type, index) in item"
            :key="index"
            :type="type"
            :eventDetails="eventDetails"
            :expanded="true"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import NoExpandedProducts from "./NoExpandedProducts.vue";
export default {
  props: ["noSectorList", "eventDetails", "group"],
  data() {
    return {
      openedExpansions: [],
    };
  },
  mounted() {
    this.openExpansions();
  },
  methods: {
    hasProductAvaiable(item) {
      return item.find((p) => {
        return !p.esgotado;
      });
    },

    rangeByType(productTypes) {
      let min = Number.MAX_SAFE_INTEGER;
      let max = Number.MIN_SAFE_INTEGER;
      productTypes.forEach((type) => {
        if (!type.encerrado) {
          const value = type.valor + type.valor_conveniencia;
          if (min > value) {
            min = value;
          }
          if (max < value) {
            max = value;
          }
        }
      });
      if (max === Number.MIN_SAFE_INTEGER && min === Number.MAX_SAFE_INTEGER) {
        max = 0;
        min = 0;
        return "";
      }
      min = this.$options.filters.currency(min);
      max = this.$options.filters.currency(max);
      return min !== max ? `A partir de ${min}` : min;
    },
    cutString(data) {
      if (data?.length > 42) return `${data.substring(0, 39)}...`;
      return data;
    },
    openExpansions() {
      let filteredProducts = this.noSectorList?.filter((i) =>
        this.group ? i[0].nome_grupo : !i[0].nome_grupo
      );
      if (this.$route.query.embed || this.$route.query.sectorMode)
        this.openedExpansions = filteredProducts.map((product, index) => index);
    },

    totalByProduct(productTypes) {
      return productTypes.reduce(
        (total, element) => element.quantidade + total,
        0
      );
    },
  },
  components: { NoExpandedProducts },
};
</script>

<style>
.expansion-content .v-expansion-panel-content__wrap {
  padding: 0px !important;
}
</style>

<style scoped>
.circle-quantity {
  width: 28px;
  height: 28px;
  border-radius: 20;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
</style>
